import { getLoggedOutConfigFor, DEFAULT_REGION, getLoggedOutFallbackLocales } from '@cbhq/intl';

/**
 * We mark the site as "Global" for these reasons
 * 1. If the country is not a go-deep country
 * 2. If the language is not supported in US
 *    - Ex: coinbase.com/ja, coinbase.com/ru - country from URL will be US but the language is not supported
 * 2. If the language is supported in US but the user is from a different country (detected via IP)
 *    - Ex: coinbase.com/ for users from India
 */
function isGlobalEdition({
  countryFromUrl = '',
  languageCode = '',
  countryFromIp = '',
  localeFromUrl = ''
}) {
  const countryConfig = getLoggedOutConfigFor(countryFromUrl);
  if (!countryConfig) {
    return true;
  }
  if (countryFromUrl === DEFAULT_REGION) {
    const lowerCaseLocaleFromUrl = localeFromUrl.toLowerCase();

    // if we're in US we need to check whether the full locale code is in the fallback list
    // we make the check case-insensitive because the same locale can be written in different cases
    const isFallbackLocale = getLoggedOutFallbackLocales().some(locale => locale.toLowerCase() === lowerCaseLocaleFromUrl);
    if (isFallbackLocale) {
      return true;
    }
    const isLangSupported = countryConfig?.supported_locales.some(locale => locale?.tag === languageCode);
    if (!isLangSupported) {
      return true;
    }
    if (countryFromIp !== countryFromUrl) {
      return true;
    }
  }
  return false;
}
export { isGlobalEdition };
//# sourceMappingURL=isGlobalEdition.js.map
